const TextoEnriquecido = (props) => {
    if (props.styles.texto) return (
        <p style={{ color: props?.styles?.colorTitulo }}>{props.styles.texto}</p>
    )

    return (
        <p style={{ color: props?.styles?.colorTitulo }}>Es un hecho establecido hace demasiado tiempo que un lector se distraerá con el contenido del texto de un sitio mientras que mira su diseño..</p>
    )
}

export default TextoEnriquecido